export default "__VITE_ASSET__BUiXldGJ__"